import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';

import ComposeMessage from 'components/chat/ComposeMessage';
import FooterButtons from 'components/shared/FooterButtons';
import Conversation from 'components/chat/Conversation';
import { drawerStyles } from 'helpers/StyleHelper';
import ConversationHeader from 'components/chat/ConversationHeader';

import {
  fetchConversationByCotenant,
  sendMessage,
  updateConversation,
  fetchMessages,
  markMessagesAsRead,
} from 'actions/chatActions';

import TabbedPanel from 'components/shared/TabbedPanel';
import styled from 'styled-components';

const MESSAGES_POLL_INTERVAL_IN_MS = 6000;

const StyledCustomDivHeight = styled.div`
  height: ${props => (props.unreadMessageCount > 0 ? 'calc(100% - 225px)' : 'calc(100% - 200px)')};
`;

let ChatDrawer = class extends Component {
  constructor(props) {
    super(props);
    this.isFirstLoad = null;
  }

  componentDidMount = () => {
    this.isFirstLoad = true;
    this.props.fetchConversationByCotenant(this.props.cotenantId).then(() => {
      this.messagePoll = this.pollMessages();
    });
  };

  componentDidUpdate = () => {
    this.isFirstLoad = false;
  };

  componentWillUnmount() {
    clearInterval(this.messagePoll);
    clearInterval(this.conversationPoll);
  }

  pollMessages = () => {
    return setInterval(() => {
      if (this.props.lastMessageTime && !this.props.loadingMessages)
        this.props.updateConversation(
          this.props.activeConversation.id,
          this.props.lastMessageTime,
          true
        );
      this.props.fetchConversationByCotenant(this.props.cotenantId, { isForMoreMessages: true });
    }, MESSAGES_POLL_INTERVAL_IN_MS);
  };

  unreadMessageCount = activeConversation => {
    if (!activeConversation) return;

    return activeConversation.landlord_unread_messages;
  };

  markAsRead = async conversationId => {
    await this.props.markMessagesAsRead(conversationId);
    this.props.fetchConversationByCotenant(this.props.cotenantId, { isForMoreMessages: true });
  };

  render() {
    const tabBodies = [this.renderDetailsBody()];
    const tabFooters = [this.renderCloseOnlyFooter()];
    drawerStyles.tabbedHeaderWrapper = {
      ...drawerStyles.tabbedHeaderWrapper,
      height: '63px',
    };
    return (
      <Fragment>
        <div className="row" style={{ ...drawerStyles.tabbedHeaderWrapper, height: 100 }}>
          <h3 style={drawerStyles.tabbedHeader}>{this.props.translate('messaging')}</h3>
          <ConversationHeader conversation={this.props.activeConversation} />
        </div>

        <TabbedPanel tabBodies={tabBodies} tabFooters={tabFooters} />
      </Fragment>
    );
  }

  renderDetailsBody = () => {
    const unreadMessageCount = this.unreadMessageCount(this.props.activeConversation);

    return (
      <Fragment>
        <StyledCustomDivHeight unreadMessageCount={unreadMessageCount}>
          <div style={{ height: '100%' }}>
            <Conversation
              loadingBar={this.isFirstLoad}
              userType="agent"
              messages={this.props.messages}
              conversation={this.props.activeConversation}
              loadingMostRecentMessages={this.props.loadingMostRecentMessages}
              fetchMessages={this.props.fetchMessages}
              unreadMessageCount={unreadMessageCount}
              markMessagesAsRead={this.markAsRead}
              isChatDrawer
              isLandlord
            />
          </div>
        </StyledCustomDivHeight>
        <div
          className="row"
          style={{
            position: 'fixed',
            left: '0',
            bottom: '68px',
            width: '100%',
            padding: '0 15px',
          }}
        >
          <ComposeMessage
            sendMessage={this.props.sendMessage}
            activeConversation={this.props.activeConversation}
            isChatDrawer
          />
          <div className="row">
            <p style={{ fontSize: '10px', margin: 0 }}>
              {' '}
              {this.props.translate('messaging.messagesWillBeViewable')}{' '}
            </p>
          </div>
        </div>
      </Fragment>
    );
  };

  renderCloseOnlyFooter = () => {
    return <FooterButtons hideSubmitButton backName="Close" backAction={this.props.toggleDrawer} />;
  };
};

ChatDrawer = connect(
  store => ({
    messages: store.chat.messages,
    conversations: store.chat.conversations,
    activeConversation: store.chat.activeConversation,
    lastMessageTime: store.chat.lastMessageTime,
    lastConversationTime: store.chat.lastConversationTime,
    loadingMoreMessages: store.chat.loadingMoreMessages,
    loadingMostRecentMessages: store.chat.loadingMostRecentMessages,
  }),
  {
    fetchConversationByCotenant,
    sendMessage,
    updateConversation,
    fetchMessages,
    markMessagesAsRead,
  }
)(ChatDrawer);

export default localize()(ChatDrawer);
